import { useContext } from 'react';
import { BreakpointContext } from '../../components/BreakpointProvider/BreakpointProvider.js';
/**
 * @example useCurrentBreakpoint() // returns current breakpoint
 */
export const useCurrentBreakpoint = () => {
  return useContext(BreakpointContext);
};